export default "__VITE_ASSET__LQOx4YBb__"